import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excludes'
})
export class ExcludesPipe implements PipeTransform {
    transform(values: Array<any>, query: any): boolean {
        return !values.includes(query);
    }
}
